import { render, staticRenderFns } from "./whiteListDetails.vue?vue&type=template&id=1488fa6c&scoped=true&"
import script from "./whiteListDetails.vue?vue&type=script&lang=js&"
export * from "./whiteListDetails.vue?vue&type=script&lang=js&"
import style0 from "./whiteListDetails.vue?vue&type=style&index=0&id=1488fa6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1488fa6c",
  null
  
)

export default component.exports